/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */
import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { StaticQuery, graphql } from 'gatsby';

import ogimage from '../../../images/sm-logo.png';
import { getLocalizedStringValue } from '../../../utils/helpers';

function SEO({
  description,
  lang,
  meta,
  title,
  img,
  location,
  noIndex,
  canonical,
  locales,
}) {
  let path = location ? location.href : '';

  // * Lang is the html-lang of the content on the page
  // * lang is the language that the page should be associated with
  // * if lang and lang dont match, that means we are on a translated paged without translated copy, i.e the copy duplicates that of the main page, so we set a canonical link

  return (
    <StaticQuery
      query={graphql`
        query {
          site {
            siteMetadata {
              title
              description
              author
              siteUrl
            }
          }
        }
      `}
      render={({ site }) => {
        const desc = getLocalizedStringValue(description, lang);

        const metaDescription = desc || site.siteMetadata.description;

        let canonicalPath = path;
        let alternativeVersions = [];

        if (location && locales) {
          if (!path) path = `${site.siteMetadata.siteUrl}${location.pathname}`;

          const defaultLangKey = locales.find(
            (localeData) => localeData.default
          ).code;
          console.log('defaultLangKey', defaultLangKey);
          // * Get the current custom locale path on the page
          const currentPrefix = locales.find(
            (localeData) => localeData.code === lang
          );
          // * Get the current custom locale path for the canonical Page
          const canonicalPrefix = locales.find(
            (localeData) => localeData.code === defaultLangKey
          );

          // * Replace the current custom locale with the canonical one
          canonicalPath = path.replace(
            currentPrefix.code,
            canonicalPrefix.code
          );

          console.log('canonicalPath', canonicalPath);

          // * Returns an array of alternative page links, based on all locales available
          alternativeVersions = locales.map((cur) => {
            if (cur.locale !== lang) {
              const alternatePath = path.replace(currentPrefix.code, cur.code);
              return {
                rel: 'alternate',
                href: alternatePath,
                hreflang: `${cur.code}`,
              };
            }
            return {
              rel: 'alternate',
              href: path,
              hreflang: `${lang}`,
            };
          });
        }
        return (
          <Helmet
            htmlAttributes={{
              lang: lang.toLowerCase(),
            }}
            title={title}
            titleTemplate={`%s | ${site.siteMetadata.title}`}
            link={[...alternativeVersions].concat(
              canonical
                ? {
                    rel: 'canonical',
                    href: canonicalPath,
                  }
                : {}
            )}
            meta={[
              {
                name: `description`,
                content: metaDescription,
              },
              {
                property: `og:title`,
                content: title,
              },
              {
                property: `og:description`,
                content: metaDescription,
              },
              {
                property: `og:type`,
                content: `website`,
              },
              {
                name: `twitter:card`,
                content: `summary`,
              },
              {
                name: `twitter:creator`,
                content: site.siteMetadata.author,
              },
              {
                name: `twitter:title`,
                content: title,
              },
              {
                name: `twitter:description`,
                content: metaDescription,
              },
            ]
              .concat(meta)
              .concat(
                img
                  ? {
                      property: `og:image`,
                      content: ogimage,
                    }
                  : {}
              )
              .concat(noIndex ? { name: 'robots', content: 'noindex' } : {})}
          />
        );
      }}
    />
  );
}

SEO.defaultProps = {
  lang: `en-US`,
  meta: [],
  description: ``,
  location: null,
  title: null,
  noIndex: null,
  canonical: false,
  img: {
    url: 'https://www.spinmaster.com/images/socialshare.png',
  },
};

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string,
  location: PropTypes.shape(),
  noIndex: PropTypes.bool,
  canonical: PropTypes.bool,
  img: PropTypes.shape(),
};

export default SEO;
